<template lang="pug">
.form-input-help
  img.help-icon(:id="_popoverId" src="../../assets/help.svg")
  b-popover(:target="_popoverId" triggers="hover" :placement="placement")
    template(v-slot:title) {{ _title }}
    .help-text(v-if="_text") {{ _text }}
    slot(name="text")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### ？ヘルプアイコンコンポーネント
 *
 * - 本文が1行の場合に使用可能
 * - 本文に改行や文字色を利用したい場合は別途コンポーネント化を検討する
 */
@Component
export default class HelpIcon extends Vue {
  @Prop({
    type: String,
    default: () => {
      return "form-input-help";
    }
  })
  popoverId!: string;

  /** タイトル */
  @Prop({
    type: String,
    default: () => {
      return Placement.AUTO;
    }
  })
  placement!: Placement;

  /** タイトル */
  @Prop({
    type: String
  })
  title!: string;

  /** 本文 */
  @Prop({
    type: String
  })
  text!: string;

  get _popoverId(): string {
    return this.popoverId;
  }

  get _title(): string {
    return this.title;
  }

  get _text(): string {
    return this.text;
  }
}
export enum Placement {
  AUTO = "auto",
  TOPRIGHT = "topright",
  TOP = "top",
  TOPLEFT = "topleft",
  BOTTOMRIGHT = "bottomright",
  BOTTOM = "bottom",
  BOTTOMLEFT = "bottomleft",
  RIGHTTOP = "righttop",
  RIGHT = "right",
  LEFTTOP = "lefttop",
  RIGHTBOTTOM = "rightbottom",
  LEFT = "left",
  LEFTBOTTOM = "leftbottom"
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

.help-icon {
  // このアイコンはmix-inのsvg-icon()を使用するとただの○に潰れてしまうのでsvg自体で色を指定している
  width: 24px;
  height: 24px;
}

.help-text {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
